export default __webpack_public_path__ + "static/media/icn-radio-on.04797b14.svg";